import React from 'react'
import axios from 'axios'
import { useState, useEffect, useRef } from 'react'
// import ProductRow from './ProductRow'
import AdminSidebar from './AdminSidebar'
// import AddProductModal from './AddProductModal'
// import EditProductModal from './EditProductModal'
import AdminNavbar from './AdminNavbar'
import OrderRow from './OrderRow'
const SERVER_URL = process.env.REACT_APP_SERVER_URL


const SearchFilter = (
    { orders, setFilteredOrders }
) => {
    return (
        <React.Fragment>
            <div className="addcat__button1">
                <span style={{ background: "#303031" }} className="filterspan">
                    <svg
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fillRule="evenodd"
                            d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                            clipRule="evenodd"
                        />
                    </svg>
                </span>
                <input
                    placeholder="Transaction id..."
                    className="tid__input"
                    type="text"
                    onChange={(e) => {
                        // eslint-disable-next-line array-callback-return
                        let filtered = orders.filter((item) => {
                            if (item.orderNumber.startsWith(e.target.value)) {
                                return item;
                            }
                            
                        })
                        setFilteredOrders(filtered)
                    }}
                />
            </div>
        </React.Fragment>
    );
};

const AdminOrder = () => {
    const [filteredOrders, setFilteredOrders] = useState([])
    const [dropdown, setDropdown] = useState(false)
    const [orders, setOrders] = useState([])
    const [rerender, setRerender] = useState(0)
    const filterRef1 = useRef();
    const filterRef2 = useRef();
    const filterRef3 = useRef();
    const filterRef4 = useRef();


    useEffect(() => {
        const closeDropdown = (e) => {
            console.log((e.path));
            // var paths = [""];
            if (e.path[0] !== filterRef1.current && e.path[0] !== filterRef2.current && e.path[0] !== filterRef3.current && e.path[0] !== filterRef4.current) setDropdown(false);
        };
        document.body.addEventListener("click", closeDropdown);
        return () => document.body.removeEventListener("click", closeDropdown);
    }, []);


    const filterOrder = (query) => {
        if (query !== "All") {
            let filtered = orders.filter((item) => item.status === query);
            setFilteredOrders(filtered);
        }
        else {
            setFilteredOrders(orders);
        }
    }

    useEffect(() => {
        axios.get(SERVER_URL + "/api/admin/get-all-orders/",
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization:
                        "Bearer " +
                        JSON.parse(localStorage.getItem("userTokenTime")).token,
                }
            }
        ).then((res) => {
            console.log(res.data.Orders);
            setOrders(res.data.Orders);
            setFilteredOrders(res.data.Orders);
            // console.log(products);
        });
    }, [rerender]);





    // const alert = (msg, type) => (
    //     <div className={`bg-${type}-200 py-2 px-4 w-full`}>{msg}</div>
    // );

    return (
        <div>
            <AdminNavbar />
            <div className='panel__container'>
                <AdminSidebar activeTab={4} />

                {/* <AddProductModal categories={categories} modal={modal} setModal={setModal} /> */}
                {/* <EditProductModal categories={categories} emodal={emodal} setEmodal={setEmodal} efData={efData} setEfdata={setEfdata} /> */}
                <div style={{ width: "87.5%", padding: "20px", marginLeft: "12.5%", background: "#F7FAFC", minHeight: "90vh" }}>
                    <div className='outer__container'>
                        <div className="">
                            <div className="orderpage__row">
                                {/* It's open the add order modal */}
                                <div
                                    // style={{ background: "#303031" }}
                                    className="idk"
                                >
                                    <div
                                        ref={filterRef1}
                                        onClick={(e) => setDropdown((prev) => !prev)}
                                        className="addcat__button"
                                    >
                                        <svg
                                            ref={filterRef2}
                                            className="mr-2"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                            style={{ width: "1.5rem" }}
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                ref={filterRef4}
                                                d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z" />
                                        </svg>
                                        <span
                                            className="pr-2"
                                            ref={filterRef3}
                                        >Filter</span>
                                    </div>
                                    <div
                                        style={{ background: "#303031" }}
                                        className={`${dropdown ? "" : "hidden"
                                            } admin__dropdown`}
                                    >
                                        <span
                                            onClick={(e) =>
                                                filterOrder("All")
                                            }
                                            className="admin__dropdown__row"
                                        >
                                            All
                                        </span>
                                        <span
                                            onClick={(e) =>
                                                filterOrder("Not Processed")
                                            }
                                            className="admin__dropdown__row"
                                        >
                                            Not Processed
                                        </span><span
                                            onClick={(e) =>
                                                filterOrder("Processing")
                                            }
                                            className="admin__dropdown__row"
                                        >
                                            Processing
                                        </span><span
                                            onClick={(e) =>
                                                filterOrder("Shipped")
                                            }
                                            className="admin__dropdown__row"
                                        >
                                            Shipped
                                        </span><span
                                            onClick={(e) =>
                                                filterOrder("Delivered")
                                            }
                                            className="admin__dropdown__row"
                                        >
                                            Delivered
                                        </span><span
                                            // onClick={(e) =>
                                            //     filterOrder("All", data, dispatch, dropdown, setDropdown)
                                            // }
                                            className="admin__dropdown__row"
                                        >
                                            Cancelled
                                        </span>
                                    </div>
                                </div>
                                <div>
                                    <SearchFilter orders={orders} setFilteredOrders={setFilteredOrders} />
                                </div>
                            </div>
                            {/*<AddCategoryModal/>*/}
                            {/* <UpdateOrderModal /> */}
                        </div>
                        <div className='inner__container2' style={{ padding: "0.5rem 1rem" }}>
                            <div style={{ height: "10px" }}></div>

                            <table className="border w-100 my-2">
                                <thead>
                                    <tr>
                                        <th className="px-4 py-2 border">Products</th>
                                        <th className="px-4 py-2 border">Total</th>
                                        <th className="px-4 py-2 border">Transaction Id</th>
                                        <th className="px-4 py-2 border">Customer</th>
                                        <th className="px-4 py-2 border">Email</th>
                                        {/* <th className="px-4 py-2 border">Phone</th> */}
                                        <th className="px-4 py-2 border">Address</th>
                                        <th className="px-4 py-2 border">Ordered at</th>
                                        <th className="px-4 py-2 border">Updated at</th>
                                        <th className="px-4 py-2 border">Status</th>
                                        <th className="px-4 py-2 border">Actions</th>
                                    </tr>

                                </thead>
                                <tbody className='cat__row'>
                                    {filteredOrders && filteredOrders.length > 0 ? (
                                        filteredOrders.map((item, key) => {
                                            return (
                                                <OrderRow
                                                    order={item}
                                                    // updateOrderStatus={(oId, status) =>
                                                    //     updateOrderStatus(oId, status)
                                                    // }
                                                    rerender={rerender}
                                                    setRerender={setRerender}
                                                    key={key}
                                                />
                                            );
                                        })
                                    ) : (
                                        <div
                                            className="noentry"
                                        >
                                            No Order found
                                        </div>
                                    )}
                                </tbody>
                            </table>
                            <div className="text-sm text-gray-600 mt-2" style={{ color: "gray", marginTop: "0.5rem", textAlign: "left" }}>
                                Total {orders && orders.length} Order found
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default AdminOrder